import { ACTION_STEPS } from '@/components/ShowModal/config';

export default {
    /**
     * Sets the state of modal visibility.
     *
     * @param {object} state Vuex state.
     * @param {boolean} modalOpen Modal visiblity state.
     */
    setModalOpen(state, modalOpen) {
        state.modalOpen = modalOpen;
    },

    /**
     * Sets the state of "is loading" flag.
     *
     * @param {object} state Vuex state.
     * @param {boolean} isLoading "Is loading" state.
     */
    setIsLoading(state, isLoading) {
        state.isLoading = isLoading;
    },

    /**
     * Sets the state of "is previous step locked" flag.
     *
     * @param {object} state Vuex state.
     * @param {boolean} isLocked "Is previous step" state.
     */
    setPreviousStepLocked(state, isLocked) {
        state.isPreviousStepLocked = isLocked;
    },

    /**
     * Sets the step.
     *
     * @param {object} state Vuex state.
     * @param {number} step  Current step.
     */
    setStep(state, step) {
        state.step = step;
    },

    /**
     * Sets the show action.
     *
     * @param {object} state Vuex state.
     * @param {string} action  Show action.
     */
    setAction(state, action) {
        state.action = action;
        state.step = ACTION_STEPS[action][0];
        state.stepsCount = ACTION_STEPS[action].length;
    },

    /**
     * Sets the show data.
     *
     * @param {object} state Vuex state.
     * @param {object} show  Show data.
     */
    setShow(state, show) {
        state.show = show;
    },

    /**
     * Sets the selected plan.
     *
     * @param {object} state Vuex state.
     * @param {string} plan  Selected plan.
     */
    setPlan(state, plan) {
        state.plan = plan;
    },

    /**
     * Sets the state of "trial enabled" flag.
     *
     * @param {object} state Vuex state.
     * @param {boolean} trialEnabled  "Trial enabled" state.
     */
    setTrialEnabled(state, trialEnabled) {
        state.trialEnabled = trialEnabled;
    },

    /**
     * Sets the selected promo.
     *
     * @param {object} state Vuex state.
     * @param {string} promo  Selected promo.
     */
    setPromo(state, promo) {
        state.promo = promo;
    },

    /**
     * Sets the card error value.
     *
     * @param {object} state Vuex state.
     * @param {string} error  Card error.
     */
    setCardError(state, error) {
        state.cardError = error;
    },

    /**
     * Sets the fresh state.
     *
     * @param {object} state Vuex state.
     */
    setFreshState(state) {
        // state
        state.isLoading = false;
        state.isPreviousStepLocked = false;
        // steps
        state.step = undefined;
        state.stepIndex = 0;
        state.stepsCount = 0;
        // data
        state.action = undefined;
        state.show = undefined;
        state.plan = undefined;
        state.trialEnabled = undefined;
        state.promo = undefined;
        // errors
        state.cardError = null;
    },
};
